import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import Box from 'components/UI/Box/Box';
import Text from 'components/UI/Text/Text';
import ProductRoom from '../ProductRoom/ProductRoom';
import { ModalTitle } from 'containers/SinglePage/Review/Review.style';
import Calendar from 'react-calendar';
import CalendarTarif from './TarifCalendar.style';
import { checkBetweenDates } from 'library/helpers/dateUtils';
import moment from 'moment';
import { loadState } from 'library/helpers/localStorage';
import Loader from 'components/Loader/Loader';

const LoadMore = ({
  handleLoadMore,
  showButton,
  buttonText,
  loading,
  loadMoreComponent,
  loadMoreStyle,
}) => {
  return (
    !!showButton && (
      <Box className="loadmore_wrapper" {...loadMoreStyle}>
        {loadMoreComponent ? (
          loadMoreComponent
        ) : (
          <Button loading={loading} onClick={handleLoadMore}>
            {buttonText || 'Load More'}
          </Button>
        )}
      </Box>
    )
  );
};

export default function SectionRoom({
  data = [],
  totalItem,
  limit,
  columnWidth,
  paginationComponent,
  handleLoadMore,
  loadMoreComponent,
  placeholder,
  loading,
  buttonText,
  rowStyle,
  columnStyle,
  loadMoreStyle,
  link,
  currency,
  hotel,
  remiseValue,
  offre,
  dateSejour
}) {
  
  const n = limit ? Number(limit) : 1;
  const limits = Array(n).fill(0);

  let showButton = data.length < totalItem;
  const [dataLoaded, setDataLoaded] = useState(false);
  let unitCurrency = currency ? currency: "€" ;
  const [ user, setUser ] = useState(loadState('user'));
  const [openModal, setOpenModal] = useState(false)
  const [currentDateSearch, setcurrentDateSearch] = useState(new Date());
  const [chambreId, setChambreId] = useState(0)
  const [listTarif, setListTarif] = useState([]);
  const [libelleChambre, setLibelleChambre] = useState('');

  const loadTarif = (id,title) => {
    setDataLoaded(false);
    setChambreId(id);
    setLibelleChambre(title);
    setOpenModal(true);
   // let mois = moment().month()+1;
   // let annee = moment().year();
    let mois = moment(currentDateSearch).month()+1;
    let annee = moment(currentDateSearch).year();
    setLoadedData(id,mois,annee);
  }

  const closeModal = () => {
    setOpenModal(false);
  }

 //cell calendar content
 const tileContent = ({ date, view }) => {
    
    const data = contentByDate(date, view);
    const items = [];
    data
    ?.forEach(el => {
      items.push(<p key={el.id} className='calendar-content-prix' >{el?.prix ? (el?.prix) : ''}</p>)
    });
   
    return <div style={{textAlign:"center"}}>{items}</div>;

  };

  const contentByDate = (date, view) => {
    
    if (view !== "month") {
      return  [];
    }
    const data = listTarif?.filter(
      (res) => moment(date, "YYYY-MM-DD").isSame(moment(res?.date, "YYYY-MM-DD"))
    );
    
    return data;
  };

  const getListeTarif = (idDevise, idChambreTypeHebergement, mois, year) => {
    return fetch(
      `${process.env.REACT_APP_API_URL}/chambre-type-hebergements/calendrier-prix/${idChambreTypeHebergement}/${idDevise}/${mois}/${year}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      }
    );
  };

  const onActiveStartDateChange = async ({ activeStartDate, view }) => {
  
    setcurrentDateSearch(activeStartDate);
    if (view === "month" && chambreId>0) {
      setLoadedData(chambreId,moment(activeStartDate).month()+1,moment(activeStartDate).year())
    }
   };

   const setLoadedData = async(chambre,mois, annee) => {
      console.log("chambre,mois, annee: ",chambre,mois, annee)
      setDataLoaded(false);
      let idDevise = (unitCurrency == 'Ar')?1:2;
      const res = await getListeTarif(
        idDevise,
        chambre,
        mois,
        annee
      );

      const listeJson = await res.json();
      setListTarif(listeJson);
      setDataLoaded(true);

   }


  return (
    <>
      <Box className="grid_wrapper" {...rowStyle}>
        {data && data.length
          ? data.map((item) => {
              return (
                <Box
                  className="grid_column"
                  width={columnWidth}
                  key={item.id}
                  {...columnStyle}
                >
                  <ProductRoom loadTarif={loadTarif} dateSejour={dateSejour} remiseValue={remiseValue} offre ={offre} hotel={hotel} currency={unitCurrency} link={link} {...item} />
                </Box>
              );
            })
          : null}

        {loading &&
          limits.map((_, index) => (
            <Box
              className="grid_column"
              width={columnWidth}
              key={index}
              {...columnStyle}
            >
              {placeholder ? placeholder : <Text content="Loading ..." />}
            </Box>
          ))}
      </Box>

      <Modal
          title={<ModalTitle as={"h3"} style={{textAlign:"center"}}> Tarifs {libelleChambre}</ModalTitle>}
          open={openModal}
          onCancel={() => closeModal()}
          width="920px"
          footer={<>
              {/* <Button type="primary" key="back" onClick={() => closeModal()}>
                    Fermer
              </Button>
              <Button type="primary" key="back" onClick={() => closeModal()}>
                    Réserver
              </Button> */}
          </>}
          maskStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
          wrapClassName="update_modal"
          zIndex={1}
          maskClosable={false}                
        >  
          <CalendarTarif className="calendar-container ">
            <div className="custom__container">
              <div className="custom__container__content">
                {!dataLoaded ?
                  <Loader/> :
                  <Calendar
                    tileContent={tileContent.bind({ listTarif })}
                    onChange={setcurrentDateSearch}
                    onClickDay={()=>{}}
                    selectRange={false}
                    defaultValue={currentDateSearch}
                    showWeekNumbers={false}
                    onActiveStartDateChange={onActiveStartDateChange.bind({
                      user,
                      chambreId,
                    })}
                  />
                }
                </div>
              </div>
          </CalendarTarif>
         
      </Modal>
      {showButton && (
        <LoadMore
          showButton={showButton}
          handleLoadMore={handleLoadMore}
          loading={loading}
          buttonText={buttonText}
          loadMoreComponent={loadMoreComponent}
          loadMoreStyle={loadMoreStyle}
        />
      )}
      {paginationComponent && (
        <Box className="pagination_wrapper">{paginationComponent}</Box>
      )}
    </>
  );
}

SectionRoom.propTypes = {
  data: PropTypes.array.isRequired,
  totalItem: PropTypes.number,
  columnWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  paginationComponent: PropTypes.element,
  handleLoadMore: PropTypes.func,
  loadMoreComponent: PropTypes.element,
  placeholder: PropTypes.element,
  loading: PropTypes.bool,
  limit: PropTypes.number,
  buttonText: PropTypes.string,
  rowStyle: PropTypes.object,
  columnStyle: PropTypes.object,
  loadMoreStyle: PropTypes.object,
};

SectionRoom.defaultProps = {
  rowStyle: {
    flexBox: true,
    flexWrap: 'wrap',
    mr: ['-10px', '-10px', '-10px', '-10px', '-10px', '-15px'],
    ml: ['-10px', '-10px', '-10px', '-10px', '-10px', '-15px'],
  },
  columnStyle: {
    pr: ['10px', '10px', '10px', '10px', '10px', '15px'],
    pl: ['10px', '10px', '10px', '10px', '10px', '15px'],
  },
  loadMoreStyle: {
    flexBox: true,
    justifyContent: 'center',
    mt: '1rem',
  },
};
